'use client';

import React from 'react';
import { useTranslation } from '@/lib/i18n';
import { X } from 'lucide-react';

interface PaymentFailedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onTryAgain: () => void;
}

const PaymentFailedModal: React.FC<PaymentFailedModalProps> = ({ isOpen, onClose, onTryAgain }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-100" onClick={onClose} />

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-101 pointer-events-none">
        <div className="bg-bg-main rounded-2xl p-8 max-w-md w-full flex flex-col items-center justify-center mx-4 pointer-events-auto shadow-2xl relative">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-text-secondary dark:text-[white] hover:opacity-80 transition-colors"
          >
            <X size={18} />
          </button>

          {/* Error Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <img src="/image/upgrade_failed.png" width={90} height={90} alt="upgrade_failed" />
            </div>
          </div>

          {/* Content */}
          <div className="text-center mb-8">
            <h2 className="text-[20px] text-text-primary mb-3">{t('Payment failed')}</h2>
            <p className="text-text-secondary text-base">
              {t("We couldn't process your payment. Please check your card or try again.")}
            </p>
          </div>

          {/* Try Again Button */}
          <button
            onClick={onTryAgain}
            className="w-[282px] py-3 px-6 rounded-full font-medium text-black bg-linear-to-r from-[#67FFFF] to-[#A772FF] hover:opacity-90 transition-opacity"
          >
            {t('Try again')}
          </button>
        </div>
      </div>
    </>
  );
};

export default PaymentFailedModal;
